export default __webpack_public_path__ + "static/media/jerry.83d18dba.jpg";